/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Route, Switch } from "react-router-dom";
import { Box } from "@material-ui/core";
//custom libraries
import { OrdersProvider } from "../context";
import { ORDER, ORDER_DETAIL } from "../constants/routes";
import { OrderDetail, OrderSearch } from ".";
import { ParamsProvider } from "../context/search-context";

export default function Order() {
  return (
    <Box display="flex" flexDirection="column" className="min-device-height">
      <Box flexGrow={1}>
        <OrdersProvider>
          <ParamsProvider>
            <Switch>
              <Route exact path={ORDER}>
                <OrderSearch />
              </Route>
              <Route exact path={ORDER_DETAIL}>
                <OrderDetail />
              </Route>
            </Switch>
          </ParamsProvider>
        </OrdersProvider>
      </Box>
    </Box>
  );
}
